import * as Yup from 'yup';

export const validationSchemaUpdateProfileWeb = new Yup.ObjectSchema({
    number: Yup.string().required('Cannot be empty').matches(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/,'Please enter 10 digit phone number'),
    address: Yup.string().required('Cannot be empty'),
    owner: Yup.string().required('Cannot be empty'),
});

export const initialValuesUpdateProfileWeb = {
    number:'',
    address:'',
    owner:'',
}

export const feildsUpdateProfileWeb =() => [
    

    {
        name:'number',
        placeholder:'Enter phone number',
        id:'number',
        type:'text',
        label:'Phone number'
    },
    {
        name:'owner',
        placeholder:'Enter onwer name',
        id:'owner',
        type:'text',
        label:'Owner'
    },
    
    {
        name:'address',
        placeholder:'Enter address here',
        id:'address',
        type:'text',
        label:'Address'
    },
]
;
export const validationSchemaUpdateProfileGoogle = new Yup.ObjectSchema({
    name: Yup.string().required('Cannot be empty'),
    contact: Yup.string().required('Cannot be empty').matches(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/,'Please enter 10 digit phone number'),
    address: Yup.string().required('Cannot be empty'),
    business_type: Yup.number().required('Cannot be empty').notOneOf([0], 'Cannot be empty'),
});

export const initialValuesUpdateProfileGoogle = {
    name:'',
    contact:'',
    address:'',
    business_type:0,
}

export const feildsUpdateProfileGoogle =(options=[]) => [
    {
        name:'name',
        placeholder:'Enter business name',
        id:'name',
        type:'text',
        label:'Business Name'
    },
    {
        name:'business_type',
        placeholder:'Business type here',
        id:'business_type',
        type:'select',
        options:[
            {
                value:0,
                label:'Select Type',
                disabled:true,
            },
            ...options
        ],
        label:'Industry Type'
    },

    {
        name:'contact',
        placeholder:'Enter phone number',
        id:'contact',
        type:'text',
        label:'Phone number'
    },
    
    {
        name:'address',
        placeholder:'Enter address here',
        id:'address',
        type:'text',
        label:'Address'
    },
    
];